import {
  call,
  select,
  takeEvery,
} from 'redux-saga/effects';

import { AxiosResponse } from 'axios';
import requestResourceFailureById from 'ia-react-core/~/actions/resource-fn/requestResourceFailureById';
import requestResourceSuccessById from 'ia-react-core/~/actions/resource-fn/requestResourceSuccessById';
import RequestResourceFailureById from 'ia-react-core/~/actions/resource/RequestResourceFailureById';
import RequestResourceSuccessById from 'ia-react-core/~/actions/resource/RequestResourceSuccessById';
import getScoped from 'ia-react-core/~/utils/redux/getScoped';
import requestResourceCompletedById from '../../../actions/resource-fn/requestResourceCompletedById';

import { ResourceAliasComposedProps } from './ResourceAlias';

type Data = { [index: string]: string | Blob };

type ArgsGetter = () => ResourceAliasComposedProps<{}>;

function* handleSuccess(argsGetter: ArgsGetter, action: RequestResourceSuccessById) {
  const { onSuccess } = argsGetter();

  if (onSuccess) {
    yield call(onSuccess, action.request as AxiosResponse<Data>);
  }
}

function* handleFailure(argsGetter: ArgsGetter, action: RequestResourceFailureById) {
  const { onFailure } = argsGetter();

  if (onFailure) {
    yield call(onFailure, action.error);
  }
}

function* handleComplete(argsGetter: ArgsGetter) {
  const { onComplete } = argsGetter();

  if (onComplete) {
    yield call(onComplete);
  }
}

export default function* resourceSaga(argsGetter: ArgsGetter): any {
  const { resourceSrc, scope } = argsGetter();

  const resourceInfo = yield select((state) => getScoped(state, resourceSrc, scope));

  if (resourceInfo) {
    yield takeEvery([
      `${requestResourceSuccessById.type}/${resourceInfo.resourceId}`,
    ], handleSuccess, argsGetter);

    yield takeEvery([
      `${requestResourceFailureById.type}/${resourceInfo.resourceId}`,
    ], handleFailure, argsGetter);

    yield takeEvery([
      `${requestResourceCompletedById.type}/${resourceInfo.resourceId}`,
    ], handleComplete, argsGetter);
  }
}
